import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import GetPaymentMethodAssetPaymentMethodType from './getPaymentMethodAssetPaymentMethodType.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Retrieves the asset for a given `}<a parentName="p" {...{
        "href": "/docs/sdk/web/2.x.x/constants/paymentMethodTypes"
      }}>{`PaymentMethodType`}</a>{`. Returns a promise that
resolves to the asset or `}<inlineCode parentName="p">{`null`}</inlineCode>{` if the asset is not available.`}</p>
    <Group summary='Parameters' mdxType="Group">
	<Item title='type' subtitle='PaymentMethodType' mdxType="Item">
		<GetPaymentMethodAssetPaymentMethodType mdxType="GetPaymentMethodAssetPaymentMethodType" />
	</Item>
    </Group>
    <Group summary='Returns' mdxType="Group">
	<Item title='backgroundColor' subtitle='object' mdxType="Item">
		The background color of the payment method button.
		<Group summary='Properties' mdxType="Group">
			<Item title='colored' subtitle='string' label='Required' mdxType="Item">
				The color to use when theme is colored.
			</Item>
			<Item title='dark' subtitle='string' label='Required' mdxType="Item">
				The color to use when theme is dark.
			</Item>
			<Item title='light' subtitle='string' label='Required' mdxType="Item">
				The color to use when theme is light.
			</Item>
		</Group>
	</Item>
	<Item title='iconUrl' subtitle='object' mdxType="Item">
		The URL of the payment method icon that is displayed on the payment method button.
		<Group summary='Properties' mdxType="Group">
			<Item title='colored' subtitle='string' label='Required' mdxType="Item">
				The color to use when theme is colored.
			</Item>
			<Item title='dark' subtitle='string' label='Required' mdxType="Item">
				The color to use when theme is dark.
			</Item>
			<Item title='light' subtitle='string' label='Required' mdxType="Item">
				The color to use when theme is light.
			</Item>
		</Group>
	</Item>
	<Item title='paymentMethodName' subtitle='string' mdxType="Item">
	    ⚠️ This property is Deprecated. Please use buttonText or displayName instead.<br /><br />
		The name of the payment method that is displayed on the payment method button. Optional.
	</Item>
	<Item title='buttonText' subtitle='string' mdxType="Item">
		The name of the payment method that is displayed on the payment method button. This will be null for payment methods without a button title. Optional.
	</Item>
	<Item title='displayName' subtitle='string' mdxType="Item">
		The name of the payment method. Optional.
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      